module.exports = __webpack_public_path__ + "assets/media/evening.69dcf2b2.mp3";